module.exports = __webpack_public_path__ + "img/icon-grid-1.509bb5af.svg";